import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  Route,
  Routes,
  Navigate,
  BrowserRouter as Router,
} from 'react-router-dom';
import App from './Home';
import Admin from './pages/admin/Admin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <>
        <Routes>
          <Route path='/' element={<App />} />
          <Route path='/admin' element={<Admin />} />
        </Routes>
      </>
    </Router>
  </React.StrictMode>,
);
